import { render, staticRenderFns } from "./SyncExistingFacebookPageModal.vue?vue&type=template&id=500b61e8&scoped=true&"
import script from "./SyncExistingFacebookPageModal.vue?vue&type=script&lang=ts&"
export * from "./SyncExistingFacebookPageModal.vue?vue&type=script&lang=ts&"
import style0 from "./SyncExistingFacebookPageModal.vue?vue&type=style&index=0&id=500b61e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b61e8",
  null
  
)

export default component.exports